import { type FunctionComponent, type PropsWithChildren, type ReactNode, memo } from "react";

import { Navigate } from "@cinnamon/design-system/hooks";

import { ROUTE } from "@/constants/route";
import { type USER_PERMISSION } from "@/constants/userPermission";
import { useHasPermissions } from "@/hooks";

export interface AuthRouteProps {
  permissions?: USER_PERMISSION[];
  isNavigateNotFound?: boolean;
  element?: ReactNode;
}

const AuthRoute: FunctionComponent<PropsWithChildren<AuthRouteProps>> = (props) => {
  const { element, children, permissions, isNavigateNotFound } = props;
  const hasPermissions = useHasPermissions();

  if (isNavigateNotFound) {
    return <Navigate to={ROUTE.NOT_FOUND.to} />;
  }

  if (permissions && !hasPermissions(permissions)) {
    return <Navigate to={ROUTE.NO_PERMISSION.to} />;
  }

  return element || children;
};

export default memo(AuthRoute);
